function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  d: "M64,45.732318 L64,45.9216696 C63.9867143,52.1304591 63.3261981,54.4110256 62.0966795,56.7100256 C60.8547415,59.0322479 59.0322479,60.8547415 56.7100256,62.0966795 C54.4110256,63.3261981 52.1304591,63.9867143 45.9216696,64 L45.732318,64 L18.267682,64 L18.0783304,64 C11.8695409,63.9867143 9.58897436,63.3261981 7.28997436,62.0966795 C4.96775214,60.8547415 3.14525855,59.0322479 1.90332051,56.7100256 L1.83023282,56.5720762 C0.659707378,54.3412301 0.0260284787,52.0534599 0,46.1067587 L0,45.9216696 L0,18.0783304 C0.0132857051,11.8695409 0.67380186,9.58897436 1.90332051,7.28997436 C3.14525855,4.96775214 4.96775214,3.14525855 7.28997436,1.90332051 L7.42792382,1.83023282 C9.6587699,0.659707378 11.9465401,0.0260284787 17.8932413,0 L18.0783304,0 L45.9216696,0 C52.1304591,0.0132857051 54.4110256,0.67380186 56.7100256,1.90332051 C59.0322479,3.14525855 60.8547415,4.96775214 62.0966795,7.28997436 C63.3261981,9.58897436 63.9867143,11.8695409 64,18.0783304 L64,18.267682 L64,45.732318 Z",
  id: "path-1"
}), React.createElement("filter", {
  x: "-10.2%",
  y: "-8.6%",
  width: "120.3%",
  height: "120.3%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Main-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "About-_-Modal-View",
  transform: "translate(-152.000000, -4722.000000)"
}, React.createElement("g", {
  id: "View",
  transform: "translate(0.000000, 190.000000)"
}, React.createElement("g", {
  id: "Item-Copy",
  transform: "translate(40.000000, 4535.000000)"
}, React.createElement("g", {
  id: "Icon",
  transform: "translate(116.000000, 0.000000)"
}, React.createElement("g", {
  id: "Path"
}, React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "ic_",
  transform: "translate(17.000000, 14.000000)",
  fill: "#838A98"
}, React.createElement("g", {
  id: "apple-seeklogo.com",
  transform: "translate(2.000000, 0.000000)"
}, React.createElement("path", {
  d: "M22.048475,17.0005942 C22.0940363,21.8432073 26.3528185,23.4547068 26.4,23.4752756 C26.36399,23.5889274 25.7195176,25.7718203 24.1562712,28.0265927 C22.8049135,29.9759577 21.4023823,31.9181819 19.1929814,31.958407 C17.022024,31.9978876 16.3239401,30.6878004 13.8419212,30.6878004 C11.360652,30.6878004 10.585049,31.9181786 8.52999599,31.9978876 C6.39736357,32.0775382 4.77338638,29.8899075 3.41079831,27.9476835 C0.626514608,23.9747986 -1.50125424,16.7212443 1.35580149,11.8249768 C2.77512583,9.39347049 5.31156571,7.85373917 8.06464441,7.81425563 C10.1588349,7.77482929 12.1355019,9.20479679 13.4157071,9.20479679 C14.6951006,9.20479679 17.0971716,7.48513556 19.6223803,7.73768955 C20.6795189,7.78111528 23.6469244,8.15914887 25.552377,10.9118903 C25.3988445,11.0058285 22.0116548,12.9519924 22.048475,17.0005988 M17.9684115,5.10927958 C19.1006404,3.75662176 19.8626957,1.87359699 19.6547988,0 C18.0227759,0.0647378959 16.0492936,1.07336227 14.87868,2.4252759 C13.8295853,3.62245837 12.9108143,5.53862529 13.1587146,7.37513973 C14.9777957,7.51404551 16.836127,6.4627976 17.9684115,5.10928178",
  id: "Shape"
}))))))));

var SvgIos = function SvgIos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ios.47d3dcda.svg";
export { ForwardRef as ReactComponent };